// This file is auto-generated by @hey-api/openapi-ts

import { z } from "zod/v3";

/**
 * AssemblySplitMode
 */
export const zAssemblySplitMode = z.enum(["LEAF", "ROOT", "ALL"]);

/**
 * DistanceUnit
 */
export const zDistanceUnit = z.enum(["m", "mm", "inch"]);

/**
 * FoldProperties
 */
export const zFoldProperties = z.object({
  angle: z.number(),
  folding_length: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
  arc: z.number().nullish().default(null),
});

/**
 * FoldFeatures
 */
export const zFoldFeatures = z.object({
  type: z.literal("Folding").optional().default("Folding"),
  properties: zFoldProperties,
});

/**
 * GDT_TYPE
 */
export const zGdtType = z.enum([
  "position",
  "parallelism",
  "flatness",
  "perpendicularity",
  "concentricity",
  "total_runout",
  "cylindricity",
  "angularity",
  "roundness",
  "circular_runout",
  "symmetry",
  "profile_line",
  "profile_plane",
  "straightness",
]);

/**
 * GraphEdgeAttr
 */
export const zGraphEdgeAttr = z.object({
  length: z.array(z.tuple([z.number()])),
  curve_type: z.array(z.tuple([z.number()])),
  arc_angle: z.array(z.tuple([z.number()])),
  origin: z.array(z.tuple([z.number(), z.number(), z.number()])),
  end: z.array(z.tuple([z.number(), z.number(), z.number()])),
});

/**
 * GraphEdgeIndex
 */
export const zGraphEdgeIndex = z.object({
  edge_index: z.tuple([z.array(z.number().int().gte(0)), z.array(z.number().int().gte(0))]),
});

/**
 * GraphGlobttr
 */
export const zGraphGlobttr = z.object({
  num_faces: z.tuple([z.number().int().gt(0)]),
  num_edges: z.tuple([z.number().int().gt(0)]),
  num_shapes: z.tuple([z.number().int().gt(0)]),
  frac_plane_faces: z.tuple([z.number()]),
  frac_cylinder_faces: z.tuple([z.number()]),
  frac_torus_faces: z.tuple([z.number()]),
  frac_plane_area: z.tuple([z.number()]),
  frac_cylinder_area: z.tuple([z.number()]),
  frac_torus_area: z.tuple([z.number()]),
  thickness: z.tuple([z.number()]),
  volume: z.tuple([z.number()]),
  area: z.tuple([z.number()]),
  dimensions: z.tuple([z.number(), z.number(), z.number()]),
});

/**
 * GraphOthers
 */
export const zGraphOthers = z.object({
  node_id: z.array(z.tuple([z.number().int().gte(0)])),
  node_face_id: z.array(z.tuple([z.number().int().gte(0)])),
  edge_id: z.array(z.tuple([z.number().int().gte(0)])),
});

/**
 * GraphPos
 */
export const zGraphPos = z.object({
  pos: z.array(z.tuple([z.number(), z.number(), z.number()])),
});

/**
 * GraphVersion
 */
export const zGraphVersion = z.object({
  fabai_version: z.string().optional(),
  graph_version: z.string().optional(),
});

/**
 * GraphX
 */
export const zGraphX = z.object({
  area: z.array(z.tuple([z.number()])),
  surface_type: z.array(z.tuple([z.number()])),
  curvature: z.array(z.tuple([z.number(), z.number(), z.number(), z.number()])),
  normal: z.array(z.tuple([z.number(), z.number(), z.number()])),
  degree: z.array(z.tuple([z.number().int().gte(0)])),
});

/**
 * Graph
 */
export const zGraph = z.object({
  x: zGraphX,
  pos: zGraphPos,
  edge_index: zGraphEdgeIndex,
  edge_attr: zGraphEdgeAttr,
  glob_attr: zGraphGlobttr,
  others: zGraphOthers,
  version: zGraphVersion.optional().default({ fabai_version: "0.0.0", graph_version: "0.0.0" }),
});

/**
 * HoleType
 */
export const zHoleType = z.enum(["hole_circular", "hole_complex", "hole_slotted", "hole_folded"]);

/**
 * HoleProperties
 */
export const zHoleProperties = z.object({
  hole_type: zHoleType,
  edge_length: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
  is_through: z.boolean().nullish().default(null),
  diameter: z.number().nullish().default(null),
});

/**
 * HoleFeatures
 */
export const zHoleFeatures = z.object({
  type: z.literal("Hole").optional().default("Hole"),
  properties: zHoleProperties,
});

/**
 * HollowSquareBar
 *
 * Hollow square bar stock
 */
export const zHollowSquareBar = z.object({
  raw_type: z.literal("hollow_square").optional().default("hollow_square"),
  width: z.number().gte(0),
  height: z.number().gte(0),
  length: z.number().gte(0),
  thickness: z.number().gte(0),
});

/**
 * HollowTube
 *
 * Hollow tube stock
 */
export const zHollowTube = z.object({
  raw_type: z.literal("hollow_tube").optional().default("hollow_tube"),
  outer_diameter: z.number().gte(0),
  length: z.number().gte(0),
  thickness: z.number().gte(0),
});

/**
 * InteractionsSourceTarget
 */
export const zInteractionsSourceTarget = z.object({
  source: z.number().int(),
  target: z.number().int(),
  contact_length: z.number(),
});

/**
 * InteractionsProperties
 */
export const zInteractionsProperties = z.object({
  contact_length: z.number().nullish().default(null),
  contact_length_details: z.array(zInteractionsSourceTarget),
});

/**
 * InteractionsFeatures
 */
export const zInteractionsFeatures = z.object({
  type: z.literal("Interactions").optional().default("Interactions"),
  properties: zInteractionsProperties,
});

/**
 * ItemSource
 */
export const zItemSource = z.object({
  kind: z.enum(["dxf", "json", "occt"]).optional().default("json"),
  ref: z.string().nullish().default(null),
  warnings: z.array(z.string()).optional().default([]),
});

/**
 * MachiningProperties
 */
export const zMachiningProperties = z.object({
  area: z.number().nullish().default(null),
});

/**
 * MachiningFeatures
 */
export const zMachiningFeatures = z.object({
  type: z.literal("Machining").optional().default("Machining"),
  properties: zMachiningProperties,
});

/**
 * MaterialGrade
 */
export const zMaterialGrade = z.enum([
  "ALUMINIUM",
  "BRASS",
  "COPPER",
  "GALVANIZED_STEEL",
  "STAINLESS_STEEL",
  "STEEL",
  "STEEL_PRE_LACQUERED",
  "STEEL_COLD_ROLLED_CORTEN",
  "STEEL_HOT_ROLLED_CORTEN",
  "ZINC",
  "BRONZE",
  "PLASTIC",
  "CAST_IRON",
  "RUBBER",
  "MAGNESIUM",
  "TITANIUM",
  "COMPOSITE",
  "WOOD",
  "INCONEL",
  "OTHER",
]);

/**
 * PartEmbeddings
 */
export const zPartEmbeddings = z.object({
  topological: z.array(z.number()).nullish().default(null),
});

/**
 * PartGDT
 */
export const zPartGdt = z.object({
  type: zGdtType,
  tolerance: z.number().nullish().default(null),
  datum: z.array(z.string()),
});

/**
 * PartRepresentation
 */
export const zPartRepresentation = z.object({
  graph: zGraph.nullish().default(null),
  shape: z.unknown().nullish().default(null),
  embeddings: zPartEmbeddings.nullish().default(null),
});

/**
 * PartRoughness
 */
export const zPartRoughness = z.object({
  value: z.number(),
});

/**
 * PartTopoComplexity
 */
export const zPartTopoComplexity = z.object({
  n_faces: z.number().int().nullish().default(null),
  n_edges: z.number().int().nullish().default(null),
  n_plane_faces: z.number().int().nullish().default(null),
  n_cylinder_faces: z.number().int().nullish().default(null),
  n_torus_faces: z.number().int().nullish().default(null),
  volume: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
});

/**
 * PartType
 */
export const zPartType = z.enum([
  "ASSEMBLY",
  "SHEET",
  "MACHINING",
  "ROUND_TUBE",
  "SQUARE_TUBE",
  "RECTANGULAR_TUBE",
  "ROUND_BAR",
  "SQUARE_BAR",
  "CONSUMABLE",
  "PROFILE",
  "OTHER",
]);

/**
 * PartMetadata
 */
export const zPartMetadata = z.object({
  files: z.array(z.string()).nullish().default(null),
  material_description: z.string().nullish().default(null),
  material_grade: zMaterialGrade.nullish().default(null),
  material_density: z.number().nullish().default(null),
  part_type: zPartType.nullish().default(null),
  shape_name: z.string().nullish().default(null),
  shape_nb: z.number().int().nullish().default(null),
  group: z.number().int().nullish().default(null),
  group_size: z.number().int().nullish().default(null),
  weight: z.number().nullish().default(null),
  weight_unit: z.enum(["g", "kg"]).nullish().default(null),
  distance_unit: zDistanceUnit.nullish().default(null),
  other_info: z.record(z.unknown()).nullish().default(null),
});

/**
 * PartVersion
 */
export const zPartVersion = z.object({
  part_version: z.string(),
});

/**
 * Point
 */
export const zPoint = z.object({
  x: z.number(),
  y: z.number(),
});

/**
 * Arc
 */
export const zArc = z.object({
  type: z.literal("arc").optional().default("arc"),
  start: zPoint,
  end: zPoint,
  center: zPoint,
  orientation: z.enum(["ccw", "cw"]).optional().default("ccw"),
});

/**
 * Line
 */
export const zLine = z.object({
  type: z.literal("line").optional().default("line"),
  start: zPoint,
  end: zPoint,
});

/**
 * Shape
 */
export const zShape = z.object({
  outer: z
    .array(
      z.union([
        z
          .object({
            type: z.literal("line"),
          })
          .and(zLine),
        z
          .object({
            type: z.literal("arc"),
          })
          .and(zArc),
      ]),
    )
    .min(1),
  holes: z
    .array(
      z.array(
        z.union([
          z
            .object({
              type: z.literal("line"),
            })
            .and(zLine),
          z
            .object({
              type: z.literal("arc"),
            })
            .and(zArc),
        ]),
      ),
    )
    .optional()
    .default([]),
});

/**
 * ItemType
 */
export const zItemType = z.object({
  id: z.string(),
  name: z.string().nullish().default(null),
  quantity: z.number().int().gte(1).optional().default(1),
  shape: zShape,
  allowed_rotations: z.array(z.number()).optional().default([0, 90, 180, 270]),
  allow_mirror: z.boolean().optional().default(false),
  source: zItemSource.optional().default({
    kind: "json",
    ref: null,
    warnings: [],
  }),
});

/**
 * SideProperties
 */
export const zSideProperties = z.object({
  length: z.number(),
  area: z.number().nullish().default(null),
  length_straight: z.number().nullish().default(null),
  length_round: z.number().nullish().default(null),
});

/**
 * SideFeatures
 */
export const zSideFeatures = z.object({
  type: z.literal("Side").optional().default("Side"),
  properties: zSideProperties,
});

/**
 * SolidRoundBar
 *
 * Solid round bar stock
 */
export const zSolidRoundBar = z.object({
  raw_type: z.literal("solid_round").optional().default("solid_round"),
  diameter: z.number().gte(0),
  length: z.number().gte(0),
});

/**
 * SolidSquareBar
 *
 * Solid square bar stock
 */
export const zSolidSquareBar = z.object({
  raw_type: z.literal("solid_square").optional().default("solid_square"),
  width: z.number().gte(0),
  height: z.number().gte(0),
  length: z.number().gte(0),
});

/**
 * BoundingBoxDimensions
 */
export const zBoundingBoxDimensions = z.object({
  raw: z
    .union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar])
    .nullish()
    .default(null),
  volume: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
  section_area: z.number().nullish().default(null),
  type: z.literal("bbox").optional().default("bbox"),
  width: z.number(),
  height: z.number(),
  length: z.number(),
});

/**
 * RectangularTubeDimensions
 */
export const zRectangularTubeDimensions = z.object({
  raw: z
    .union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar])
    .nullish()
    .default(null),
  volume: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
  section_area: z.number().nullish().default(null),
  type: z.literal("rectangular_tube").optional().default("rectangular_tube"),
  thickness: z.number(),
  width: z.number(),
  height: z.number(),
  length: z.number(),
});

/**
 * RoundBarDimensions
 */
export const zRoundBarDimensions = z.object({
  raw: z
    .union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar])
    .nullish()
    .default(null),
  volume: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
  section_area: z.number().nullish().default(null),
  type: z.literal("round_bar").optional().default("round_bar"),
  diameter: z.number(),
  length: z.number(),
});

/**
 * RoundTubeDimensions
 */
export const zRoundTubeDimensions = z.object({
  raw: z
    .union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar])
    .nullish()
    .default(null),
  volume: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
  section_area: z.number().nullish().default(null),
  type: z.literal("round_tube").optional().default("round_tube"),
  thickness: z.number(),
  diameter: z.number(),
  length: z.number(),
});

/**
 * SheetDimensions
 */
export const zSheetDimensions = z.object({
  raw: z
    .union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar])
    .nullish()
    .default(null),
  volume: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
  section_area: z.number().nullish().default(null),
  type: z.literal("sheet").optional().default("sheet"),
  thickness: z.number(),
  unfolded_width: z.number(),
  unfolded_length: z.number(),
});

/**
 * Source
 */
export const zSource = z.enum(["2d", "3d", "multi_modal"]);

/**
 * SplittingStrategy
 */
export const zSplittingStrategy = z.enum(["labels", "solids", "shells", "compounds", "root"]);

/**
 * PycadRequest
 */
export const zPycadRequest = z.object({
  url: z.string(),
  partId: z.string(),
  fileId: z.string(),
  partAnalysisId: z.string(),
  name: z.string(),
  companyId: z.string(),
  quoteRequestId: z.string().nullish().default(null),
  partType: zPartType.nullish().default(null),
  partTypeMapper: z.record(zPartType).nullish().default(null),
  assemblySplitMode: zAssemblySplitMode.optional().default("LEAF"),
  computePreview: z.boolean(),
  computeGltf: z.boolean(),
  computeFeatures: z.boolean(),
  computeInteractionFeatures: z.boolean(),
  computeGraphs: z.boolean(),
  computeTopologicalEmbedding: z.boolean(),
  computeFlatPattern: z.boolean(),
  shouldUpdatePartType: z.boolean().optional().default(true),
  shouldPredictAfterAnalyze: z.boolean().optional().default(false),
  quoteRequestLineId: z.string().nullish().default(null),
  splittingStrategy: zSplittingStrategy.optional().default("labels"),
  authorizeConsumable: z.boolean().optional().default(true),
  kFactor: z.number().gte(0).lte(1).optional().default(0.44),
});

/**
 * SquareBarDimensions
 */
export const zSquareBarDimensions = z.object({
  raw: z
    .union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar])
    .nullish()
    .default(null),
  volume: z.number().nullish().default(null),
  area: z.number().nullish().default(null),
  section_area: z.number().nullish().default(null),
  type: z.literal("square_bar").optional().default("square_bar"),
  width: z.number(),
  height: z.number(),
  length: z.number(),
});

/**
 * PartDimensions
 */
export const zPartDimensions = z.object({
  bbox: zBoundingBoxDimensions.nullish().default(null),
  part: z
    .discriminatedUnion("type", [
      zSheetDimensions.extend({ type: z.literal("sheet") }),
      zSquareBarDimensions.extend({ type: z.literal("square_bar") }),
      zRoundBarDimensions.extend({ type: z.literal("round_bar") }),
      zRoundTubeDimensions.extend({ type: z.literal("round_tube") }),
      zRectangularTubeDimensions.extend({ type: z.literal("rectangular_tube") }),
    ])
    .nullish()
    .default(null),
});

/**
 * StatusType
 */
export const zStatusType = z.enum(["ERROR", "PROCESSED", "STANDBY"]);

/**
 * FlatPatternFileResponse
 *
 * Flat pattern of an analyzed part (pycad STEP or pyplan DXF), as a nesting-core item.
 */
export const zFlatPatternFileResponse = z.object({
  id: z.string(),
  partId: z.string(),
  companyId: z.string(),
  partAnalysisId: z.string(),
  flatPattern: zItemType.nullish().default(null),
  flatPatternStatus: zStatusType,
});

/**
 * PycadChildPartResponseLegacyChildren
 */
export const zPycadChildPartResponseLegacyChildren: z.AnyZodObject = z.object({
  name: z.string(),
  urlPng: z.string().url().min(1).nullish().default(null),
  urlGltf: z.string().url().min(1).nullish().default(null),
  url: z.string().url().min(1),
  urlGraph: z.string().url().min(1).nullish().default(null),
  graphVersion: z.string(),
  featuresStatus: zStatusType,
  previewStatus: zStatusType,
  gltfStatus: zStatusType,
  embeddingStatus: zStatusType,
  topologicalEmbeddingStatus: zStatusType,
  partType: z.string().nullish().default(null),
  groupSize: z.number().int().nullish().default(null),
  shapes: z.array(z.unknown()).nullish().default(null),
  embedding: z.array(z.number()).nullish().default(null),
  topologicalEmbedding: z.array(z.number()).nullish().default(null),
  children: z.array(z.lazy(() => zPycadChildPartResponseLegacyChildren)),
});

/**
 * PycadChildPartResponseLegacy
 */
export const zPycadChildPartResponseLegacy = z.object({
  id: z.string(),
  companyId: z.string(),
  partAnalysisId: z.string(),
  quoteRequestId: z.string().nullable(),
  shouldAnalyzeChildren: z.boolean(),
  computeGraphs: z.boolean(),
  computeFeatures: z.boolean(),
  computeTopologicalEmbedding: z.boolean(),
  shouldPredictAfterAnalyze: z.boolean(),
  children: z.array(zPycadChildPartResponseLegacyChildren),
});

/**
 * PycadGltfResponse
 */
export const zPycadGltfResponse = z.object({
  id: z.string(),
  partId: z.string(),
  companyId: z.string(),
  partAnalysisId: z.string(),
  urlGltf: z.string().url().min(1).nullish().default(null),
  gltfStatus: zStatusType,
});

/**
 * PycadPreviewResponse
 */
export const zPycadPreviewResponse = z.object({
  id: z.string(),
  partId: z.string(),
  companyId: z.string(),
  partAnalysisId: z.string(),
  urlPng: z.string().url().min(1).nullish().default(null),
  previewStatus: zStatusType,
  isAssembly: z.boolean().nullish().default(null),
});

/**
 * PycadFileQueueResponse
 */
export const zPycadFileQueueResponse = z.union([
  zPycadPreviewResponse,
  zPycadGltfResponse,
  zFlatPatternFileResponse,
]);

/**
 * PycadTopologicalEmbeddingResponse
 */
export const zPycadTopologicalEmbeddingResponse = z.object({
  id: z.string(),
  companyId: z.string(),
  partAnalysisId: z.string(),
  topologicalEmbedding: z.array(z.number()).nullish().default(null),
  topologicalEmbeddingStatus: zStatusType,
});

/**
 * ToleranceType
 */
export const zToleranceType = z.enum(["numerical", "iso"]);

/**
 * PartTolerance
 */
export const zPartTolerance = z.object({
  type: zToleranceType,
  raw_value: z.string(),
  span: z.number().nullish().default(null),
});

/**
 * PartAngleMeasure
 */
export const zPartAngleMeasure = z.object({
  tolerance: zPartTolerance.nullish().default(null),
  type: z.literal("angle"),
  angle: z.number(),
});

/**
 * PartDiameterMeasure
 */
export const zPartDiameterMeasure = z.object({
  tolerance: zPartTolerance.nullish().default(null),
  type: z.literal("diameter"),
  diameter: z.number(),
});

/**
 * PartLinearMeasure
 */
export const zPartLinearMeasure = z.object({
  tolerance: zPartTolerance.nullish().default(null),
  type: z.literal("linear"),
  length: z.number(),
});

/**
 * PartRadiusMeasure
 */
export const zPartRadiusMeasure = z.object({
  tolerance: zPartTolerance.nullish().default(null),
  type: z.literal("radius"),
  radius: z.number(),
});

/**
 * PartThreadingMeasure
 */
export const zPartThreadingMeasure = z.object({
  tolerance: zPartTolerance.nullish().default(null),
  type: z.literal("threading"),
  diameter: z.number(),
});

/**
 * PartComplexity
 */
export const zPartComplexity = z.object({
  topo: zPartTopoComplexity.nullish().default(null),
  roughnesses: z.array(zPartRoughness).nullish().default(null),
  gdts: z.array(zPartGdt).nullish().default(null),
  measures: z
    .array(
      z.union([
        z
          .object({
            type: z.literal("linear"),
          })
          .and(zPartLinearMeasure),
        z
          .object({
            type: z.literal("diameter"),
          })
          .and(zPartDiameterMeasure),
        z
          .object({
            type: z.literal("radius"),
          })
          .and(zPartRadiusMeasure),
        z
          .object({
            type: z.literal("angle"),
          })
          .and(zPartAngleMeasure),
        z
          .object({
            type: z.literal("threading"),
          })
          .and(zPartThreadingMeasure),
      ]),
    )
    .nullish()
    .default(null),
});

/**
 * Part
 */
export const zPart = z.object({
  source: zSource,
  version: zPartVersion,
  metadata: zPartMetadata.nullish().default(null),
  features: z
    .array(
      z.union([
        z
          .object({
            type: z.literal("Hole"),
          })
          .and(zHoleFeatures),
        z
          .object({
            type: z.literal("Folding"),
          })
          .and(zFoldFeatures),
        z
          .object({
            type: z.literal("Side"),
          })
          .and(zSideFeatures),
        z
          .object({
            type: z.literal("Interactions"),
          })
          .and(zInteractionsFeatures),
        z
          .object({
            type: z.literal("Machining"),
          })
          .and(zMachiningFeatures),
      ]),
    )
    .nullish()
    .default(null),
  dimensions: zPartDimensions.nullish().default(null),
  complexity: zPartComplexity.nullish().default(null),
  representations: zPartRepresentation.nullish().default(null),
});

/**
 * PycadChildPartResponse
 */
export const zPycadChildPartResponse = z.object({
  id: z.string(),
  companyId: z.string(),
  partAnalysisId: z.string(),
  assemblyStatus: zStatusType,
  quoteRequestId: z.string().nullish().default(null),
  shouldAnalyzeChildren: z.boolean().nullish().default(null),
  shouldPredictAfterAnalyze: z.boolean().nullish().default(null),
  computeGraphs: z.boolean().nullish().default(null),
  computeFeatures: z.boolean().nullish().default(null),
  computeTopologicalEmbedding: z.boolean().nullish().default(null),
  computeFlatPattern: z.boolean().nullish().default(null),
  featuresStatus: zStatusType.nullish().default(null),
  name: z.string().nullish().default(null),
  url: z.string().url().min(1).nullish().default(null),
  urlPng: z.string().url().min(1).nullish().default(null),
  urlGraph: z.string().url().min(1).nullish().default(null),
  previewStatus: zStatusType.nullish().default(null),
  urlGltf: z.string().url().min(1).nullish().default(null),
  gltfStatus: zStatusType.nullish().default(null),
  graph_version: z.string().nullish().default(null),
  embeddingStatus: zStatusType.nullish().default(null),
  topologicalEmbeddingStatus: zStatusType.nullish().default(null),
  part: zPart.nullish().default(null),
  embedding: z.array(z.number()).nullish().default(null),
  topologicalEmbedding: z.array(z.number()).nullish().default(null),
  flatPattern: zItemType.nullish().default(null),
  flatPatternStatus: zStatusType.nullish().default(null),
});

/**
 * PycadPartResponse
 */
export const zPycadPartResponse = z.object({
  id: z.string(),
  companyId: z.string(),
  partAnalysisId: z.string(),
  quoteRequestLineId: z.string().nullish().default(null),
  quoteRequestId: z.string().nullish().default(null),
  part: zPart.nullish().default(null),
  graphStatus: zStatusType,
  urlGraph: z.string().url().min(1).nullish().default(null),
  graphVersion: z.string().nullish().default(null),
  featuresStatus: zStatusType,
  shouldUpdatePartType: z.boolean().nullish().default(null),
  computePreview: z.boolean(),
  computeGltf: z.boolean(),
  computeFeatures: z.boolean(),
  computeFlatPattern: z.boolean(),
  computeInteractionFeatures: z.boolean(),
  computeGraphs: z.boolean(),
  computeTopologicalEmbedding: z.boolean(),
  shouldPredictAfterAnalyze: z.boolean(),
});

/**
 * PycadPartQueueResponse
 */
export const zPycadPartQueueResponse = z.union([
  zPycadPartResponse,
  zPycadTopologicalEmbeddingResponse,
  zPycadChildPartResponse,
  zPycadChildPartResponseLegacy,
]);

/**
 * PycadResponse
 */
export const zPycadResponse = z.union([zPycadPartQueueResponse, zPycadFileQueueResponse]);
